angular
	.module 'App.Repository'
	.factory 'ReturnReasonCodeRepository', ['BaseRepository', (BaseRepository) ->
		class ReturnReasonCodeRepository extends BaseRepository
			@resource = '/return_reason_codes'
			@isRestricted = true

			findByQuery: (query = null) ->
				if _.isEmpty(query)
					query = @createQuery()

				if !query.isSorted()
					query.sortBy 'code', 'ASC'

				super query

		return new ReturnReasonCodeRepository
	]
